import React, { useState } from "react";

export default function WelcomeModal() {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <div className="welcomeModalOverlay" onClick={() => setOpen(false)}>
      <div className="welcomeModal" onClick={(e) => e.stopPropagation()}>
        <button
          className="welcomeModalClose"
          onClick={() => setOpen(false)}
          aria-label="Cerrar"
        >
          ×
        </button>

        <img
          className="welcomeModalLogo"
          src="https://firebasestorage.googleapis.com/v0/b/coqueteria-b7812.appspot.com/o/default%2Flogo.jpg?alt=media&token=8d13d404-2cbf-48d9-8e14-578f9f4f5b74"
          alt="La Coqueteria"
        />

        <p className="welcomeModalText">
          ✨Estamos dando turnos por mensaje directo o WhatsApp para ir a tu
          espacio ya que por el momento nos estamos generando una nueva
          estructura del negocio físico ✨🏍️
        </p>

        <div className="welcomeModalButtons">
          <a
            className="welcomeModalButton welcomeModalWhatsapp"
            href="https://api.whatsapp.com/send/?phone=5492213990248&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ir al Whatsapp
          </a>
          <a
            className="welcomeModalButton welcomeModalIg"
            href="https://www.instagram.com/lacoqueteria.lp/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ir a IG
          </a>
        </div>
      </div>
    </div>
  );
}
